import {Moment} from 'moment';
import React from 'react';

import {
  CalendarEntriesByDate,
  CalendarEntry,
  CalendarFilesByDate,
  CalendarInteraction,
  CalendarProcessTasksByDate,
  CalendarProjectsByDate,
  CalendarRequest,
  CalendarRequestsByDate,
  CalendarView as CalendarViewType,
  LayeredCalendarItems,
  ViewRange,
} from 'calendar/CalendarConstants';
import DataConnector from 'connect/DataConnector';
import getTestProps from 'test/lib/cypress/getTestProps';
import * as nyc from 'ui-library/NYC';

import {ProcessTaskForCalendarGraphQL} from '../../graphql-fragments/processes/__generated/ProcessTaskForCalendarGraphQL';
import {calendarDidMount, calendarDidUpdate} from './CalendarComponentUtil';
import CalendarFilter from './CalendarFilter';
import CalendarStore from './CalendarStore';
import CalendarToolbar from './CalendarToolbar';
import CalendarView from './CalendarView';

interface Props {}

interface EnhancedProps {
  currentView: CalendarViewType;
  entries: CalendarEntriesByDate;
  files: CalendarFilesByDate;
  requests: CalendarRequestsByDate;
  processTasks: CalendarProcessTasksByDate;
  interact: CalendarInteraction;
  isLoadingData: boolean;
  layeredItems: LayeredCalendarItems<CalendarEntry | CalendarRequest | ProcessTaskForCalendarGraphQL>;
  projects: CalendarProjectsByDate;
  today: Moment;
  viewLabel: string;
  viewRange: ViewRange;
  visibleDate: Moment;
}

class EntryCalendarConnector extends DataConnector<Props, EnhancedProps> {
  shouldSubscribeToRedux = false;
  stores = [CalendarStore];

  enhanceProps(): EnhancedProps {
    return {
      currentView: this.calendarStore().getCurrentView(),
      interact: this.calendarStore().getInteract(),
      isLoadingData: this.calendarStore().isLoadingData(),
      today: this.calendarStore().getToday(),
      viewLabel: this.calendarStore().getViewLabel(),
      viewRange: this.calendarStore().getViewRange(),
      visibleDate: this.calendarStore().getVisibleDate(),
      projects: this.calendarStore().getProjects(),
      layeredItems: this.calendarStore().getLayeredItems(),
      entries: this.calendarStore().getEntries(),
      files: this.calendarStore().getNonEntryFiles(),
      requests: this.calendarStore().getRequests(),
      processTasks: this.calendarStore().getProcessTasks(),
    };
  }
}

class EntryCalendar extends React.Component<Props & EnhancedProps> {
  componentDidMount(): void {
    calendarDidMount(this.props.viewRange, this.props.currentView);
  }

  componentDidUpdate(prevProps: Props & EnhancedProps): void {
    calendarDidUpdate(
      prevProps.viewRange,
      this.props.viewRange,
      prevProps.currentView,
      this.props.currentView
    );
  }

  render(): JSX.Element {
    return (
      <div
        className="u-small-spacing-top u-spacing-left"
        {...getTestProps({component: 'EntryCalendar', element: 'root'})}
      >
        <CalendarToolbar
          currentView={this.props.currentView}
          isLoadingData={this.props.isLoadingData}
          today={this.props.today}
          viewLabel={this.props.viewLabel}
          viewRange={this.props.viewRange}
          visibleDate={this.props.visibleDate}
        />
        <div className="u-spacing-bottom">
          <CalendarFilter />
        </div>
        <nyc.Row>
          <nyc.Col md={16}>
            <CalendarView
              currentView={this.props.currentView}
              entries={this.props.entries}
              requests={this.props.requests}
              files={this.props.files}
              processTasks={this.props.processTasks}
              interact={this.props.interact}
              isLoadingData={this.props.isLoadingData}
              layeredItems={this.props.layeredItems}
              projects={this.props.projects}
              showWeeklyFileActivity={true}
              today={this.props.today}
              viewRange={this.props.viewRange}
              visibleDate={this.props.visibleDate}
            />
          </nyc.Col>
        </nyc.Row>
      </div>
    );
  }
}

export default EntryCalendarConnector.connect(EntryCalendar);
